import { Link } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { ArrowRight, Clock, BookOpen, Target } from 'lucide-react';

function PlaygroundPage() {
  const practiceModes = [
    {
      id: 'fill-in-the-blank',
      title: 'Fill in the Blank',
      description: 'Complete sentences with missing words to test your vocabulary retention',
      icon: Target,
      badge: 'Available',
      badgeVariant: 'default' as const,
      available: true,
      href: '/practice/fill-in-the-blank-select',
      stats: {
        sessions: 0,
      }
    },
    {
      id: 'flashcards',
      title: 'Flashcards',
      description: 'Review word definitions and examples with interactive flashcards',
      icon: BookOpen,
      badge: 'Coming Soon',
      badgeVariant: 'secondary' as const,
      available: false,
      href: '#'
    },
  ];

  return (
    <main className="flex-1 px-4 py-8">
      <div className="mx-auto max-w-4xl">
        {/* Page Header */}
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold text-foreground sm:text-3xl">Practice Modes</h1>
          <p className="mt-2 text-muted-foreground">
            Choose a practice mode to strengthen your vocabulary
          </p>
        </div>

        {/* Practice Mode Cards */}
        <div className="grid gap-4 sm:grid-cols-2">
          {practiceModes.map((mode) => {
            const Icon = mode.icon
            const isAvailable = mode.available

            return (
              <Card
                key={mode.id}
                className={`relative overflow-hidden transition-all ${
                  isAvailable
                    ? "border-border hover:border-primary/50 hover:shadow-md cursor-pointer"
                    : "border-border/50 opacity-70"
                }`}
              >
                {isAvailable ? (
                  <Link to={mode.href} className="block p-6">
                    <div className="flex items-start justify-between">
                      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
                        <Icon className="h-6 w-6 text-primary" />
                      </div>
                      <Badge variant={mode.badgeVariant} className="text-xs">
                        {mode.badge}
                      </Badge>
                    </div>
                    <h3 className="mt-4 text-lg font-semibold text-foreground">
                      {mode.title}
                    </h3>
                    <p className="mt-1 text-sm text-muted-foreground line-clamp-2">
                      {mode.description}
                    </p>
                    {mode.stats && (
                      <div className="mt-4 flex items-center gap-4 text-xs text-muted-foreground">
                        <span>{mode.stats.sessions} sessions completed</span>
                      </div>
                    )}
                    <div className="mt-4 flex items-center justify-between">
                      <Button size="sm" className="gap-2">
                        Start Practice
                        <ArrowRight className="h-4 w-4" />
                      </Button>
                    </div>
                  </Link>
                ) : (
                  <div className="p-6">
                    <div className="flex items-start justify-between">
                      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-muted">
                        <Icon className="h-6 w-6 text-muted-foreground" />
                      </div>
                      <Badge variant={mode.badgeVariant} className="text-xs">
                        <Clock className="mr-1 h-3 w-3" />
                        {mode.badge}
                      </Badge>
                    </div>
                    <h3 className="mt-4 text-lg font-semibold text-muted-foreground">
                      {mode.title}
                    </h3>
                    <p className="mt-1 text-sm text-muted-foreground/70 line-clamp-2">
                      {mode.description}
                    </p>
                    <div className="mt-4">
                      <Button size="sm" variant="outline" disabled className="gap-2 bg-transparent">
                        Coming Soon
                      </Button>
                    </div>
                  </div>
                )}
              </Card>
            )
          })}
        </div>
      </div>
    </main>
  );
}

export default PlaygroundPage;